import { defineStore } from 'pinia'
import OneNetworkConfig from '@/onenetwork/core/onenetwork.config'

const baseRoute = OneNetworkConfig.baseRoutePath

export const useOneNetworkNotificationStore = defineStore('onenetwork.notification', {
  state: (): any => ({
    items: []
  }),
  getters:{
    totalUnread: (state: any) => state.items.filter((item: any) => !item.read).length
  },
  persist: true,
  actions: {
    pushNotification(item: any) {
      this.items.push(item)
    },

    readNotification(targetItem: any) {
      this.items = this.items.map((item: any) => {
        if (item.messageId === targetItem.messageId) {
          return { ...item, read: true }
        }
        return item
      })
    },

    readAllNotification() {
      this.items = this.items.map((item: any) => ({
        ...item,
        read: true
      }))
    },

    removeNotification(targetItem: any) {
      this.items = this.items.filter((item: any) => item.messageId !== targetItem.messageId)
    },

    removeAllNotifications() {
      this.items = []
    }
  }
})
